module.exports = __webpack_public_path__ + "static/media/student41.e5ce3974.png";